
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'audit-log-field-types-displaying-values-bool-value',
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    setup (props) {
        const strValue = (props.value) ? 'Yes' : 'No'
        return { strValue }
    }
})
